import React from 'react';
import PropTypes from 'prop-types';
import HotjarMasked from '../HotjarMasked';

import '../SubscriptionPreview/module.css';

const CustomAgreementPreview = ({
  subscription_type: subscriptionType,
  support_plan: supportPlan,
  formatted_end_date: formattedEndDate,
  success_manager: successManager
}) => (
  <div className="custom-agreement-preview">
    <div className="row">
      <div styleName="label-group" className="col-xs-6">
        <span>Subscription Type</span>
        <div className="subscription-type">{subscriptionType}</div>
      </div>
      <div styleName="label-group" className="col-xs-6">
        <span>Support Plan</span>
        <div className="support-plan">{supportPlan || '–'}</div>
      </div>
    </div>
    <div className="row">
      <div styleName="label-group" className="col-xs-6">
        <span>Renewal Date</span>
        <div>{formattedEndDate || '–'}</div>
      </div>
    </div>
  </div>
);

CustomAgreementPreview.propTypes = {
  subscription_type: PropTypes.string.isRequired,
  support_plan: PropTypes.string,
  formatted_end_date: PropTypes.string,
  success_manager: PropTypes.string
};

CustomAgreementPreview.defaultProps = {
  name: '',
  master_tenant: '',
  subscription_type: ''
};

export default CustomAgreementPreview;
